import { render } from "./Price.vue?vue&type=template&id=256eec30&scoped=true"
import script from "./Price.vue?vue&type=script&lang=js"
export * from "./Price.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-256eec30"

export default script